// Boss part textures (built once at boot). The Singularity Heart draws its own
// procedural textures on first spawn.
import type Phaser from 'phaser';
import { buildTitanArt } from './art-titan';
import { buildWardenArt } from './art-warden';

export function buildBossArt(scene: Phaser.Scene): void {
  for (const build of [buildWardenArt, buildTitanArt]) {
    try {
      build(scene);
    } catch (err) {
      console.error('[bosses] art builder failed', err);
    }
  }
}
